import {
  BankAccount,
  BankAccountType,
  StripeBankAccountStatus
} from '@umss/shared/data-access';

export const MOCK_BANK_ACCOUNT: BankAccount = {
  id: '1',
  bankName: 'Chase',
  routingNumberMasked: '****0021',
  accountNumberMasked: '****7890',
  accountType: BankAccountType.CHECKING,
  isPrimary: true,
  isExternallyManaged: false,
  status: StripeBankAccountStatus.Verified
};

export const MOCK_BANK_ACCOUNTS: BankAccount[] = [
  {
    id: 'dfc97720-ea61-4582-b007-1bc428fb2e45',
    bankName: 'Wells Fargo',
    routingNumberMasked: '****0248',
    accountNumberMasked: '****1526',
    accountType: BankAccountType.CHECKING,
    isPrimary: true,
    isExternallyManaged: false,
    status: StripeBankAccountStatus.Verified
  },
  {
    id: 'af62bcff-eb8b-47e2-b3bc-683c061a6fee',
    bankName: 'City Bank',
    routingNumberMasked: '****0089',
    accountNumberMasked: '****•411',
    accountType: BankAccountType.CHECKING,
    isPrimary: false,
    isExternallyManaged: false,
    status: StripeBankAccountStatus.NotLinked
  }
];
